import { ThemeProvider } from "@mui/material";
import React, { useMemo, useState } from "react";
import gene20DarkTheme from "./darkTheme/gene20DarkTheme";
import gene20LightTheme from "./LightTheme/gene20LightTheme";
import { useSelector } from "react-redux";

const Theme = ({ children }) => {
  const darkMode = useSelector((state) => state.theme.darkMode);
  const [theme, setTheme] = useState(darkMode);

  const selectedTheme = useMemo(() => {
    if (darkMode) {
      setTheme(gene20DarkTheme);
    } else {
      setTheme(gene20LightTheme);
    }
  }, [darkMode]);

  const defaultTheme = useMemo(()=> (theme), [theme]);
  // const defaultTheme = darkMode ? gene20DarkTheme : gene20LightTheme;

  return <ThemeProvider theme={defaultTheme}>{children}</ThemeProvider>;
};
export const withTheme = (Component) => {
  return (props) => {
    const darkMode = useSelector((state) => state.theme.darkMode);

    return (
      <Theme darkMode={darkMode}>
        <Component {...props} />
      </Theme>
    );
  };
};
